import React from 'react';
import { Box, IconButton } from '@material-ui/core';

import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';

import {
  useStyles,
  CounterLogic,
  PropTypes,
} from './counter.module';

const Counter = (props) => {
  const classes = useStyles();
  const { values } = CounterLogic(props);

  return (
    <Box className={classes[values.isBackgroundWhite || values.rootClass]}>
      <IconButton className={classes[values.buttonClass]} onClick={props.decrement}>
        <RemoveIcon />
      </IconButton>
      <div className={classes[values.counterClass]}>
        <p>{props.counter}</p>
        <p>{values.text}</p>
      </div>
      <IconButton className={classes[values.buttonClass]} onClick={props.increment}>
        <AddIcon />
      </IconButton>
    </Box>
  );
};

Counter.propTypes = {
  text: PropTypes.string,
  type: PropTypes.string,
  counter: PropTypes.number,
  increment: PropTypes.func,
  decrement: PropTypes.func,
  isBackgroundWhite: PropTypes.bool,
};

export default Counter;
